import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'

export default class extends Controller {
  static values = {
    isOpened: { type: Boolean, default: false }
  }

  static targets = ['filterContainer', 'openButton', 'closeButton']

  connect () {
    useClickOutside(this)
    window.addEventListener('turbo:frame-load', this.onFrameLoad)
  }

  disconnect () {
    window.removeEventListener('turbo:frame-load', this.onFrameLoad)
  }

  onFrameLoad = (event) => {
    const frame = event.target
    if (frame.id === 'sidebar') {
      this.isOpenedValue = false
      useClickOutside(this)
    }
  }

  isOpenedValueChanged (value) {
    if (value === true) {
      this.filterContainerTarget.classList.add('reflection_filter-opened')
      this.openButtonTarget.classList.add('hidden')
      this.closeButtonTarget.classList.remove('hidden')
    } else {
      this.filterContainerTarget.classList.remove('reflection_filter-opened')
      this.openButtonTarget.classList.remove('hidden')
      this.closeButtonTarget.classList.add('hidden')
    }
  }

  open () {
    this.isOpenedValue = true
  }

  close () {
    this.isOpenedValue = false
  }

  clickOutside (event) {
    if (this.isOpenedValue === true) {
      event.preventDefault()
      this.isOpenedValue = false
    }
  }
}
